function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.5s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.5s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.25s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.25s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}));
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 60,
  width: 15,
  height: 140,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}));
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.25s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.25s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}));
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 120,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.5s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.5s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}));
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 140,
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.7f31bf62.svg";
export { ForwardRef as ReactComponent };